import React from 'react';
import cn from 'classnames';
import { NavLink } from 'react-router-dom';

import LogoIconBase from 'assets/img/logo.svg';

import { LanguageSwitcher } from 'components/LanguageSwitcher';

import styles from './Header.module.scss';

const LogoIcon = LogoIconBase as unknown as React.ComponentType<{
  className?: string;
}>;

const Header = ({ className }: { className: any }) => (
  <div className={cn(styles.header, className)}>
    <NavLink to="/courses">
      <LogoIcon className={styles.logo} />
    </NavLink>
    <LanguageSwitcher />
  </div>
);

Header.defaultProps = {
  withMenu: false,
};

export default React.memo(Header) as any;
